module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.7be29a62.png";